// Module
var code = "<template><require from=\"../../../../components/custom-button/custom-button\"></require><require from=\"../../../../components/text-box/text-box\"></require><div class=\"column grow-xs-1\"><iframe class=\"grow-xs-1\" src=\"${iframeUrl}\" style=\"border: none;\"></iframe></div></template>";
// Exports
module.exports = code;